import { SizableText, XStack } from 'tamagui';

interface SpeciesAiResultBadgeProps {
  icon?: React.ReactNode;
  label: string;
}

export const SpeciesAiResultBadge = ({
  icon,
  label,
}: SpeciesAiResultBadgeProps): React.ReactElement => (
  <XStack
    alignItems="center"
    backgroundColor="$infoBg"
    gap="$2"
    paddingHorizontal="$2"
    paddingVertical="$1"
  >
    {icon}
    <SizableText color="$info" fontFamily="$bold" size="$2">
      {label}
    </SizableText>
  </XStack>
);
